const LOCAL_API_URL = 'http://localhost:3000';
const DEPLOY_API_URL = 'https://real-state-project-deploy.onrender.com';
const isLocalhost =
  typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);
const envApiUrl = process.env.REACT_APP_API_URL?.trim();

const rawApiUrl = envApiUrl || (isLocalhost ? LOCAL_API_URL : DEPLOY_API_URL);

export const API_BASE_URL = rawApiUrl.replace(/\/+$/, '');

export const buildAssetUrl = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;

  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  const assetPath = cleanPath.includes('/uploads') ? cleanPath : `/uploads${cleanPath}`;

  return `${API_BASE_URL}${assetPath}`;
};
